import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/Speech.scss";

interface Organizer {
  id: string;
  name: string;
  position: string;
  message: string;
  image: string;
}

const PrevArrow = ({ onClick }: any) => (
  <div className="custom-arrow prev" onClick={onClick}>
    &lt;
  </div>
);

const NextArrow = ({ onClick }: any) => (
  <div className="custom-arrow next" onClick={onClick}>
    &gt;
  </div>
);

const Speech: React.FC = () => {
  const [organizers, setOrganizers] = useState<Organizer[]>([]);

  useEffect(() => {
    fetch("/resources/data.json")
      .then((res) => res.json())
      .then((data) => {
        if (data?.organizers) {
          setOrganizers(data.organizers);
        }
      })
      .catch(console.error);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <section className="speech-section">
      <Slider {...settings}>
        {organizers.map((org) => (
          <div className="speech-slide" key={org.id}>
            <div className="speech-card">
              <div className="speech-left">
                <img src={org.image} alt={org.name} />
              </div>

              <div className="speech-right">
                <div className="speech-header">
                  <h1>{org.name}</h1>
                  <p className="position">{org.position}</p>
                </div>

                <div
                  className="speech-message"
                  dangerouslySetInnerHTML={{ __html: org.message }}
                />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Speech;
